import { render, staticRenderFns } from "./StudentContactFormView.vue?vue&type=template&id=98f3ce1e&scoped=true&"
import script from "./StudentContactFormView.vue?vue&type=script&lang=js&"
export * from "./StudentContactFormView.vue?vue&type=script&lang=js&"
import style0 from "./StudentContactFormView.vue?vue&type=style&index=0&id=98f3ce1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f3ce1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCol,VForm,VRow,VSubheader})
